import { BrandCode, EnvConfig } from 'types';

const config: EnvConfig = {
	env: 'dev',
	endpoints: {
		affirmApi: 'https://sandbox.affirm.com/js/v2/affirm.js',
		dictionaryApi: 'https://www.test1.royalcaribbean.com/bin/services/royal/dictionary',
		utilsApi: 'https://www.test1.royalcaribbean.com/utils/service',
	},
	publicKeys: {
		launchDarklyClientSideId: '61f97f6d6e987d174e325522',
		guestAccountClientId: 'gju41SBogc51n296591o7r57lg6XDDkSPE14yXo64m0lna6wx4wiMI6M7ZWJVDKP',
		utilsApiKey: '73cab9ae-48ae-48ca-b614-cde8d1872285',
	},
	brands: {
		[BrandCode.Celebrity]: {
			baseUrl: 'https://www.stage1.celebritycruises.com',
			mapsBaseUrl: 'https://www.celebritycruises.com',
			publicKeys: {
				affirmApiKey: '2NYPH852CY0PCTX0',
				appDynamicsAppKey: 'AD-AAB-AAT-KTS',
			},
			scripts: {
				appDynamics: '//cdn.appdynamics.com/adrum/adrum-latest.js',
			},
			resources: {
				favicon: '/favicon.ico',
			},
		},
		[BrandCode.RoyalCaribbean]: {
			baseUrl: 'https://www.test1.royalcaribbean.com',
			mapsBaseUrl: 'https://www.royalcaribbean.com/content/dam',
			publicKeys: {
				affirmApiKey: 'C2JKB5O3PQ0H9R6X',
				appDynamicsAppKey: 'AD-AAB-AAU-NMZ',
			},
			scripts: {
				appDynamics: '//cdn.appdynamics.com/adrum/adrum-latest.js',
			},
			resources: {
				favicon: '/content/dam/royal/resources/icons/logo/favicon.ico',
			},
		},
	},
};

export default config;
